const Spacer = () => {
  return <div className={"h-full w-full"}></div>;
};

export default Spacer;
